import React from 'react';
import { HiTag } from 'react-icons/hi2';
import ComingSoon from './ComingSoon';

const TrainingTagsSettings: React.FC = () => {
  return (
    <ComingSoon
      title="Training Tags"
      description="Create and customize training tags to better categorize your workouts. Set up custom training types and organize your fitness activities."
      icon={HiTag}
    />
  );
};

export default TrainingTagsSettings;